const CLOUDINARY_CLOUD_NAME = (process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || "").trim();
const CLOUDINARY_UPLOAD_PRESET = (process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || "").trim();

export function isCloudinaryUploadConfigured() {
  return Boolean(CLOUDINARY_CLOUD_NAME && CLOUDINARY_UPLOAD_PRESET);
}

async function uploadFileToCloudinary(file, options = {}) {
  if (!isCloudinaryUploadConfigured()) {
    throw new Error(
      "Cloudinary uploads need REACT_APP_CLOUDINARY_CLOUD_NAME and REACT_APP_CLOUDINARY_UPLOAD_PRESET in .env.local. Restart the React dev server after changing them."
    );
  }

  const {
    resourceType = "image",
    folder = "",
    tags = [],
    filename = "",
  } = options;

  const formData = new FormData();
  if (filename) {
    formData.append("file", file, filename);
    formData.append("filename_override", filename);
  } else {
    formData.append("file", file);
  }
  formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
  if (folder) formData.append("folder", folder);
  if (tags.length > 0) formData.append("tags", tags.join(","));

  const response = await fetch(
    `https://api.cloudinary.com/v1_1/${encodeURIComponent(CLOUDINARY_CLOUD_NAME)}/${resourceType}/upload`,
    {
      method: "POST",
      body: formData,
    }
  );

  let payload = null;
  try {
    payload = await response.json();
  } catch {
    payload = null;
  }

  if (!response.ok) {
    const cloudinaryMessage = payload?.error?.message || "";
    if (cloudinaryMessage.toLowerCase().includes("upload preset not found")) {
      throw new Error(
        "Cloudinary upload preset not found. Check that REACT_APP_CLOUDINARY_UPLOAD_PRESET exactly matches an unsigned upload preset in this Cloudinary cloud, then restart the React dev server."
      );
    }

    const message = cloudinaryMessage || "Cloudinary rejected the upload.";
    throw new Error(message);
  }

  const url = payload?.secure_url || payload?.url;
  if (!url) {
    throw new Error("Cloudinary upload finished without returning a URL.");
  }

  return {
    url,
    publicId: payload?.public_id || "",
    resourceType: payload?.resource_type || resourceType,
  };
}

export async function uploadImageToCloudinary(file) {
  if (!file || !file.type?.startsWith("image/")) {
    throw new Error("Only image files can be uploaded.");
  }

  const result = await uploadFileToCloudinary(file, { resourceType: "image" });
  return result.url;
}

export async function uploadTextToCloudinary(text, options = {}) {
  const trimmedText = String(text || "").trim();
  if (!trimmedText) {
    throw new Error("Text file is empty.");
  }

  const filename = options.filename || `learnhut-submission-${Date.now()}.txt`;
  const blob = new Blob([trimmedText], { type: "text/plain;charset=utf-8" });

  return uploadFileToCloudinary(blob, {
    resourceType: "raw",
    folder: options.folder,
    tags: options.tags,
    filename,
  });
}
